import React, {Component} from 'react';
import validate from './validation';
import {Grid} from 'material-ui';
import {Field, reduxForm} from 'redux-form';
import {InputTextField} from '../../../components/fields/field_input_text';
import {Heading} from '../../../components/heading/heading';
import {BackButton} from '../../../components/buttons/BackButton';
import {SaveButton} from '../../../components/buttons/SaveButton';

class MyAccountEditForm extends Component {
    render() {
        const {
            handleSubmit,
            loading,
            touched,
            pristine,
            passwordUpdatedAt,
            formValues
        } = this.props;

        const hasCurrentPassword =
            formValues && formValues.values.current_password.length;

        let isCurrentPassFieldRequired = false;
        let isNewPassFieldRequired = false;

        if (hasCurrentPassword) {
            isNewPassFieldRequired = true;
        }
        if (
            formValues &&
            (formValues.values.new_password ||
                formValues.values.new_password_repeat)
        )
            isCurrentPassFieldRequired = true;

        if (passwordUpdatedAt === null) {
            isCurrentPassFieldRequired = true;
        }

        return (
            <form onSubmit={handleSubmit(this.props.handleFormSubmit)}>
                <Heading title={'Change Account Information'} />
                <Grid container id='text-fields'>
                    <Grid item xs={12} md={8} lg={6}>
                        <Field
                            name='name'
                            component={InputTextField}
                            label='Full Name'
                            fullWidth={true}
                            InputLabelProps={{required: true}}
                        />
                        <Field
                            name='email'
                            component={InputTextField}
                            label='Email address'
                            fullWidth={true}
                            InputLabelProps={{required: true}}
                        />
                        <Field
                            name='current_password'
                            component={InputTextField}
                            label='Current Password'
                            fullWidth={true}
                            helperText='Type your current password'
                            InputLabelProps={{
                                required: isCurrentPassFieldRequired
                            }}
                            type='password'
                        />
                        <Field
                            name='new_password'
                            component={InputTextField}
                            label='New Password'
                            fullWidth={true}
                            helperText={
                                hasCurrentPassword
                                    ? ''
                                    : 'Field disabled. Fill in Current Password field first!'
                            }
                            InputLabelProps={{required: isNewPassFieldRequired}}
                            disabled={!isNewPassFieldRequired}
                            type='password'
                        />
                        <Field
                            name='new_password_repeat'
                            component={InputTextField}
                            label='Repeat New Password'
                            fullWidth={true}
                            helperText={
                                hasCurrentPassword
                                    ? ''
                                    : 'Field disabled. Fill in Current Password field first!'
                            }
                            InputLabelProps={{required: isNewPassFieldRequired}}
                            disabled={!isNewPassFieldRequired}
                            type='password'
                        />
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} md={8} lg={6}>
                        <SaveButton
                            type='submit'
                            loading={loading}
                            disabled={(!touched && pristine) || loading}
                            variant='raised'
                            color='primary'
                            className='floatRight'
                        />
                        <BackButton
                            link={'/'}
                            style={{marginRight: 15}}
                            variant='raised'
                            className='floatRight'
                        />
                    </Grid>
                </Grid>
            </form>
        );
    }
}

export default reduxForm({
    form: 'MyAccountEditForm',
    enableReinitialize: true,
    destroyOnUnmount: false,
    anyTouched: false,
    validate
})(MyAccountEditForm);



// WEBPACK FOOTER //
// ./src/containers/myaccount/forms/MyAccountEditForm.jsx